import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const FloatingActionButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMainFeed = location?.pathname === '/main-feed';

  if (!isMainFeed) {
    return null;
  }

  const handleClick = () => {
    navigate('/create-post');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-[50] flex items-center gap-3 px-6 py-4 bg-accent text-accent-foreground rounded-full shadow-lg hover:shadow-xl hover-glow transition-therapeutic press-scale focus-ring group"
      aria-label="Share your story"
    >
      <Icon 
        name="Plus" 
        size={24} 
        color="currentColor" 
        strokeWidth={2}
        className="transition-therapeutic group-hover:rotate-90"
      />
      <span className="hidden sm:inline font-medium text-base">
        Share Your Story
      </span>
    </button>
  );
};

export default FloatingActionButton;